import React from 'react';
import { Modal } from 'reactstrap';
import './ContentEnrichmentModal.css';

export const ContentEnrichmentModal = ({
  isOpen,
  onClose,
  onConfirm,
  remainingCreditsAfterActivation,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      className="content-enrichment-modal"
      backdrop={true}
      keyboard={true}
    >
      <div className="content-enrichment-modal-content">
        <div className="content-enrichment-modal-header">
          <div className="content-enrichment-modal-title-wrapper">
            <img src="/Images/black-magic-icon.png" alt="magic" className="content-enrichment-modal-icon" />
            <h2 className="content-enrichment-modal-title">Activer l'enrichissement du contenu</h2>
          </div>
        </div>
        <div className="content-enrichment-modal-body">
          <p className="content-enrichment-modal-description">
            L'enrichissement du contenu  <strong>améliore la qualité</strong> et la <strong>pertinence des textes générés</strong> grâce à l'IA.
          </p>
          {remainingCreditsAfterActivation !== null && (
            <div className="content-enrichment-credits-box">
              <span className="content-enrichment-credits-label">Crédits restants après activation : </span>
              <span className="content-enrichment-credits-value">{remainingCreditsAfterActivation}</span>
            </div>
          )}
        </div>
        <div className="content-enrichment-modal-footer">
          <button
            className="content-enrichment-modal-cancel-button"
            onClick={onClose}
          >
            Annuler
          </button>
          <button
            className="content-enrichment-modal-confirm-button"
            onClick={onConfirm}
          >
            Activer l'enrichissement
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ContentEnrichmentModal;

